import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo } from '../Logo';
import { ScanLine, ClipboardCheck, FolderOpen, MessageSquare, Globe, ScrollText, ArrowRight } from 'lucide-react';
const navItems = [{
  to: '/assessments',
  label: 'Assessments',
  icon: ClipboardCheck
}, {
  to: '/dossiers',
  label: 'Dossiers',
  icon: FolderOpen
}, {
  to: '/chat',
  label: 'Chat',
  icon: MessageSquare
}, {
  to: '/markets',
  label: 'Markets',
  icon: Globe
}, {
  to: '/policies',
  label: 'Policies',
  icon: ScrollText
}];
export function Sidebar() {
  return <aside className="flex h-full w-64 shrink-0 flex-col border-r border-slate-200 bg-white" data-id="element-2477" data-mp="30qakcsex1be0">
      <div className="px-5 py-5" data-id="element-2478" data-mp="35rzt21eo1cyx">
        <NavLink to="/dossiers" aria-label="Taama home" data-id="element-2479" data-mp="3aq1cwojx1gbg">
          <Logo size={120} data-id="element-2480" data-mp="3apro34alxf7c" />
        </NavLink>
      </div>

      <div className="px-3" data-id="element-2481" data-mp="1bdp8i553t4yy">
        <NavLink to="/new-scan" className="flex w-full items-center justify-between rounded-xl bg-evergreen px-4 py-3 text-sm font-semibold text-white transition hover:bg-forest-green" data-id="element-2482" data-mp="1begyn0fxmahu">
          <span className="flex items-center gap-2" data-id="element-2483" data-mp="1w1dq5lgibud8">
            <ScanLine className="h-4 w-4" data-id="element-2484" data-mp="1r943ceaovaf6" />
            New Scan
          </span>
          <ArrowRight className="h-4 w-4" data-id="element-2485" data-mp="1m9zvbqzi3iqf" />
        </NavLink>
      </div>

      <nav className="mt-6 flex-1 space-y-1 px-3" data-id="element-2486" data-mp="1m86p2cssv0iy">
        {navItems.map(({
        to,
        label,
        icon: Icon
      }) => <NavLink key={to} to={to} className={({
        isActive
      }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition ${isActive ? 'bg-pearl-aqua/40 text-forest-green' : 'text-slate-600 hover:bg-slate-50 hover:text-evergreen'}`} data-id="element-2487" data-mp="1i6uudsv2jp3w">
            <Icon className="h-4.5 w-4.5 h-[18px] w-[18px]" data-id="element-2488" data-mp="211i5371roh1c" />
            {label}
          </NavLink>)}
      </nav>

      <div className="border-t border-slate-100 px-5 py-4 text-xs text-slate-400" data-id="element-2489" data-mp="pjh5mi1ixzuv">
        Need help?{' '}
        <a href="mailto:contact@taama.ai" className="font-medium text-forest-green hover:underline" data-id="element-2490" data-mp="r0wa9jiew1ip">
          contact@taama.ai
        </a>
      </div>

      <div className="flex items-center gap-3 border-t border-slate-100 px-4 py-4" data-id="element-2491" data-mp="vy673k84rfgk">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forest-green text-sm font-semibold text-white" data-id="element-2492" data-mp="hzy7f4jpm01p">
          K
        </div>
        <div className="min-w-0" data-id="element-2493" data-mp="8aeipi9bfbyx">
          <p className="truncate text-sm font-medium text-evergreen" data-id="element-2494" data-mp="89d8fg04iti9">Krystle</p>
          <p className="truncate text-xs text-slate-400" data-id="element-2495" data-mp="d26dk4zi83uv">taama-krystle@yopmail.com</p>
        </div>
      </div>
    </aside>;
}